export default __webpack_public_path__ + "static/media/mini_satcom.7319a2de.svg";